module.exports = __webpack_public_path__ + "static/images/jf-activity-bg04.63d7078.png";